export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8870.26c02710.jpg";